import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config/trading";
import { apiErrorMessage } from "../lib/errorMessage";

const DEFAULT_LIVE_MAX_TRADE_USDT = 50;
const BTC_USDT = "BTC-USDT";
const ETH_USDT = "ETH-USDT";
const SOL_USDT = "SOL-USDT";
const OKB_USDT = "OKB-USDT";

const configFromAutomation = (liveAutomation) => {
  const symbols = liveAutomation?.symbols || [];
  return {
    max_trade_usdt: liveAutomation?.max_trade_usdt || DEFAULT_LIVE_MAX_TRADE_USDT,
    btc: symbols.includes(BTC_USDT) || symbols.length === 0,
    eth: symbols.includes(ETH_USDT) || symbols.length === 0,
    sol: symbols.includes(SOL_USDT),
    okb: symbols.includes(OKB_USDT),
    interval_seconds: liveAutomation?.interval_seconds || 300,
    paper_enabled: liveAutomation?.paper_enabled ?? true,
  };
};

function selectedLiveSymbols(liveConfig) {
  return [
    liveConfig.btc ? BTC_USDT : null,
    liveConfig.eth ? ETH_USDT : null,
    liveConfig.sol ? SOL_USDT : null,
    liveConfig.okb ? OKB_USDT : null,
  ].filter(Boolean);
}

export function useCredentialAndLiveActions({ dashboard, setDashboard, loadDashboard, setOrderMessage }) {
  const liveAutomation = dashboard?.live_automation;
  const [liveConfig, setLiveConfig] = useState(() => configFromAutomation(liveAutomation));

  useEffect(() => {
    setLiveConfig(configFromAutomation(liveAutomation));
  }, [liveAutomation, setLiveConfig]);

  const toggleLiveAutomation = async () => {
    const symbols = selectedLiveSymbols(liveConfig);
    if (!liveConfig.paper_enabled && !dashboard.okx_credentials.configured) {
      setOrderMessage("Connect OKX before enabling live-only automation.");
      return;
    }
    try {
      const response = await axios.put(`${API}/live-automation`, {
        enabled: !dashboard.live_automation.enabled,
        max_trade_usdt: Number(liveConfig.max_trade_usdt),
        symbols,
        interval_seconds: Number(liveConfig.interval_seconds),
        paper_enabled: liveConfig.paper_enabled,
      });
      setDashboard((current) => ({ ...current, live_automation: response.data }));
      setOrderMessage(response.data.enabled ? "USDT automation enabled with strict max order cap." : "USDT automation stopped.");
      await loadDashboard();
    } catch (err) {
      setOrderMessage(apiErrorMessage(err, "Live automation could not be changed."));
    }
  };

  return { liveConfig, setLiveConfig, toggleLiveAutomation };
}